import { Component, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
	selector: 'independant-layout',
	templateUrl: './independant-layout.component.html',
	styleUrls: [ `independant-layout.component.css` ]
})
export class IndependantLayoutComponent implements OnInit {


	logoSrc: SafeUrl = "";


	constructor(
		private customerService: CustomerService,
	) {}


	ngOnInit() {

		this.logoSrc = this.customerService.getLoadedLogo();

	}

}
